import { render } from "./DepartmentSetting.vue?vue&type=template&id=39b82f10"
import script from "./DepartmentSetting.vue?vue&type=script&lang=js"
export * from "./DepartmentSetting.vue?vue&type=script&lang=js"

import "./DepartmentSetting.vue?vue&type=style&index=0&id=39b82f10&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__